import { render, staticRenderFns } from "./storeDetails.vue?vue&type=template&id=00e56035&scoped=true"
import script from "./storeDetails.vue?vue&type=script&lang=js"
export * from "./storeDetails.vue?vue&type=script&lang=js"
import style0 from "./storeDetails.vue?vue&type=style&index=0&id=00e56035&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e56035",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e56035')) {
      api.createRecord('00e56035', component.options)
    } else {
      api.reload('00e56035', component.options)
    }
    module.hot.accept("./storeDetails.vue?vue&type=template&id=00e56035&scoped=true", function () {
      api.rerender('00e56035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/platformCard/storeDetails.vue"
export default component.exports